__turbopack_context__.v({
  "btn__close": "Modal-module-scss-module__GBQoIG__btn__close",
  "modal": "Modal-module-scss-module__GBQoIG__modal",
});
